import { motion } from "framer-motion";

export default function PriorityFixes({ data, onFixClick, loadingFix }) {
  if (!data?.issues?.length) return null;

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg">

      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        ⚡ High Impact Fixes
      </h3>

      <div className="space-y-3">

        {data.issues.map((issue, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex justify-between items-center border rounded-xl p-4 hover:shadow-md transition"
          >

            <span className="text-sm text-gray-700">
              {issue}
            </span>

            <button
              onClick={() => onFixClick(issue)}
              disabled={loadingFix}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1 rounded-lg text-sm transition"
            >
              {loadingFix ? "..." : "Fix"}
            </button>

          </motion.div>
        ))}

      </div>
    </div>
  );
}